import {

  ChevronsUpDown,
  MessageSquareText,
} from "lucide-react";
import React, { useState } from "react";
import MessageModal from "../Modal/MessageModal";
import { calculateAgeFromDOB, can_visit, exchangeDate } from "../../helpers";
import BulkMessageSendModal from "../Modal/BulkMessageSendModal";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function PatientDataTableForReview(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    messageTemplate = [],
    account_id,
    location_id,
    smsLimit,
    setSmsLimit = () => {},
    dataLoading,
    setDataLoading = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
    selectedPatientData,
    setSelectedPatientData = () => {}
  } = props;

  // const sendBulkSms = () => {
  //   console.log(getTableIdToContents("bulk", checkedIds));
  // };

  const [activePatientViewModal, setActivePatientViewModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [patientData, setPatientData] = useState({});
  const [orderBy, setOrderBy] = useState();
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };

  const handleSendMessageModal = (data) => {
    setPatientData(data)
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handlePatientViewModal = (data) => {
    setPatientData(data);
    setActivePatientViewModal(!activePatientViewModal);
  }

  const removeSelection = () => {
    setSelectedPatientData([]);
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  return (
    <>
      {(checkSelected && can_visit('_bulk_message')) && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            <BulkMessageSendModal
              // checkedIds={checkedIds}
              messageTemplate={messageTemplate}
              account_id={account_id}
              location_id={location_id}
              smsLimit={smsLimit}
              setSmsLimit={setSmsLimit}
              checkedIds={Array.from(globalCheckedIds)}
              setGlobalCheckedIds={setGlobalCheckedIds}
              selectedPatientData={selectedPatientData}
              setSelectedPatientData={setSelectedPatientData}
            />

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0" style={{ height: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("last_name");
                }}
                className={orderBy === "last_name" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Last Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("first_name");
                  }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Date of Birth <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Age <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("sex");
                }}
                className={orderBy === "sex" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Gender <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("mobile_phone");
                }}
                className={
                  orderBy === "mobile_phone" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("insurance_name");
                }}
                className={
                  orderBy === "insurance_name" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Insurance Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("last_visit");
                }}
                className={
                  orderBy === "last_visit" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Last Visited <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id} pointer`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.accountName}
                        </td>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.locationName}
                        </td>
                      </>
                    )}

                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      <img
                        src={item.avatarImgUrl}
                        alt=""
                        width={28}
                        height={28}
                        style={{
                          marginRight: "10px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                      {item.lastName}
                    </td>

                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      {item.firstName}
                    </td>

                    <td onClick={() => handlePatientViewModal(item)}>
                      {exchangeDate(item.dob)}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {calculateAgeFromDOB(item.dob)}y
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item?.sex === 'M' ? 'Male' : item?.sex === 'F' ? 'Female' : 'Others' || ''}
                    </td>
                    <td className="bulk" onClick={() => handlePatientViewModal(item)}>
                      {item.mobilePhone}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {item.insuranceName}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {exchangeDate(item.lastVisit)}
                    </td>
                    <td className="bulk hidden">
                      {item.id}
                    </td>

                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns" phone={item.mobilePhone}>
                        {can_visit("_single_message") && (
                          <button
                            type="button"
                            className="docpro_icon_btn"
                            onClick={() => handleSendMessageModal(item)}
                          >
                            <MessageSquareText width={20} height={20} />
                            <span className="docpro_tip">Request Review</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 12 : 10}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2.5 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageModal
          patient_id={patientData.id}
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          phone={patientData.mobilePhone}
          messageTemplate={messageTemplate}
          message_type="Review"
          account_id={account_id}
          location_id={location_id}
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}